angular.module('gym.calendar').controller('EditEventContainerCtrl', ["$scope", "gym", "event", "classrooms", "styles", "EventService", function($scope, gym, event, classrooms, styles, EventService) {
  $scope.gym = gym.attributes;
  $scope.event = event;
  $scope.styles = styles;
  $scope.classrooms = classrooms;
  return EventService.eventTypesWithDeleted(event.event_type_id || event.event_type_ids).then(function(types) {
    return $scope.eventTypes = types;
  });
}]);
